import { render, staticRenderFns } from "./AssetMwcComponent.vue?vue&type=template&id=5f9203ee&scoped=true&"
import script from "./AssetMwcComponent.vue?vue&type=script&lang=js&"
export * from "./AssetMwcComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetMwcComponent.vue?vue&type=style&index=0&id=5f9203ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9203ee",
  null
  
)

export default component.exports